var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-list"},[_c('v-select',{staticClass:"select-list",attrs:{"label":"text","value":_vm.checklistValue.value,"options":_vm.getOptions,"reduce":(country) => country.value,"placeholder":_vm.checklistValue.fieldTip},on:{"search":_vm.asyncFind,"input":_vm.onChangeFieldValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }